const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || 'Não foi possível concluir a solicitação.');
  }

  return data;
}

export function createQuote(payload) {
  return request('/quotes.php', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function loginAdmin(payload) {
  return request('/login.php', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function logoutAdmin() {
  return request('/logout.php', { method: 'POST' });
}

export function getCurrentAdmin() {
  return request('/me.php');
}

export function listQuotes() {
  return request('/admin-quotes.php');
}

export function updateQuoteStatus(id, status) {
  return request('/admin-quotes.php', {
    method: 'PATCH',
    body: JSON.stringify({ id, status }),
  });
}

export function updateQuote(payload) {
  return request('/admin-quotes.php', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export function deleteQuote(id) {
  return request('/admin-quotes.php', {
    method: 'DELETE',
    body: JSON.stringify({ id }),
  });
}

export function listFinances(month) {
  const query = month ? `?month=${encodeURIComponent(month)}` : '';

  return request(`/admin-finances.php${query}`);
}

export function listFinancesByPeriod(startMonth, endMonth, options = {}) {
  const params = new URLSearchParams();

  if (startMonth) {
    params.set('startMonth', startMonth);
  }

  if (endMonth) {
    params.set('endMonth', endMonth);
  }

  if (options.startDate) {
    params.set('startDate', options.startDate);
  }

  if (options.endDate) {
    params.set('endDate', options.endDate);
  }

  return request(`/admin-finances.php?${params.toString()}`);
}

export function createFinanceEntry(payload) {
  return request('/admin-finances.php', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function updateFinanceEntry(payload) {
  return request('/admin-finances.php', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export function updateFinanceStatus(id, status) {
  return request('/admin-finances.php', {
    method: 'PATCH',
    body: JSON.stringify({ id, status }),
  });
}

export function deleteFinanceEntry(id) {
  return request('/admin-finances.php', {
    method: 'DELETE',
    body: JSON.stringify({ id }),
  });
}

export function getFinanceEntry(id) {
  return request(`/admin-finances.php?id=${encodeURIComponent(id)}`);
}
